module.exports = __webpack_public_path__ + "static/media/head_tug.c9861f73.png";